<script lang="ts">
import Vue, { CreateElement, PropType, RenderContext, VNode } from 'vue';

import { Nullable } from '@/utils/types';

import Label from '@/bundles/Common/components/Label.vue';

interface IProps {
  value: Nullable<string | number>;
  href: Nullable<string>;
}

// Web links open in a new tab; tel: and mailto: hand off to the device instead.
const isWebHref = (href: string): boolean => /^(https?:)?\/\//.test(href);

export default Vue.extend({
  name: 'CustomFieldValue',

  functional: true,

  props: {
    value: {
      type: [String, Number] as PropType<Nullable<string | number>>,
      default: null,
    },
    href: {
      type: String as PropType<Nullable<string>>,
      default: null,
    },
  },

  render (h: CreateElement, { props, data }: RenderContext<IProps>): VNode {
    if (!props.href) {
      return h(Label, { ...data, props: { value: props.value } });
    }

    const newTabAttrs = isWebHref(props.href) ? { target: '_blank', rel: 'noopener noreferrer' } : {};

    return h('a', { ...data, attrs: { ...data.attrs, href: props.href, ...newTabAttrs } }, String(props.value));
  },
});
</script>
